export default Object.freeze({
  Pending: 1,
  Success: 2,
  Failed: 3,
});
